import React from "react";
import "./CommonHeadingBottomLine.css";

function CommonHeadingBottomLine({ headingText }) {
  return (
    <section className="CommonHeadingBottomLine">
      <div class="section_heading_div">
        <p class="heading_text">{headingText}</p>
      </div>
    </section>
  );
}

export default CommonHeadingBottomLine;
